import { symbol } from '@/utils/siteTitle';
import { getSessionItem } from '@/utils/utils';
import Mock from 'mockjs';

const dict = {
  核生化: [
    '40',
    'jishu',
    'dongaohui',
    'xiamenhaiguan',
    'jilin',
    'yangshi',
    'shenzhengwan',
    'chongqing'
  ],
  智慧边防: [
    'yili',
    'kezhou',
    'bozhou',
    'hetian',
    'hami',
    'kashi',
    'tacheng',
    'changji',
    'akesu',
    'ale',
    'liaoning'
  ],
  北京地铁: [
    'xidanb1',
    'xidanb2',
    'xidane1',
    'xidana',
    'xidanc',
    'xidan',
    'xidan4f',
    'xidan4h',
    'xidan4bei',
    'xidan4nan',
    'xizhimen3f',
    'xizhimen13e'
  ],
  海关: [
    'shanghai',
    'wulumuqi',
    'lanzhou',
    'beijing',
    'nanjing',
    'nanning',
    'nanchang',
    'hefei',
    'huhehaote',
    'haerbing',
    'dalian',
    'tianjing',
    'taiyuan',
    'ninghai',
    'guangdong',
    'chengdu',
    'lasa',
    'gongbei',
    'kunming',
    'hangzhou',
    'wuhan',
    'jinan',
    'guiyang'
  ],
  华泰诺安测试平台: ['40-2']
};

const keyMap = {
  核生化: 'heshenghua',
  智慧边防: 'zhihuibianfang',
  北京地铁: 'beijingditie',
  海关: 'haiguan'
};

const defaultOffices = '海关';

export function getOffices() {
  const mock = Mock.mock;
  const title = getSessionItem(symbol);
  const keys = Object.keys(dict);
  let key = '';
  if (title) key = keys.find(e => title.indexOf(e) !== -1) || defaultOffices;
  const list = dict[key].map(e => `_${keyMap[key]}.${e}`);

  const data = mock({
    [`data|${list.length}`]: [
      {
        'id|+1': 10001,
        'dept|+1': list
      }
    ]
  }).data;
  return data;
}

export function getDepts(data) {
  return data.map(e => e.dept);
}
